import http from '../jslibs/axios/http';

//服务管理 获取服务列表
export const servicelist = () => (http.get('/v1/cms/Server'));

//服务管理 删除服务
export const deleteService = uuid => (http.delete(`/v1/cms/Server/${uuid}`));

//服务管理 新建服务
export const newService = data => (http.post('/v1/cms/Server', data));

//服务管理 编辑服务
export const editService = data => (http.put(`/v1/cms/Server/${data.uuid}`, data));

//服务管理 服务详情
export const serviceDetail = uuid => (http.get(`/v1/cms/Server/${uuid}`));

//服务管理 获取佣金比例
export const commissionRate = () => (http.get('/v1/cms/CommissionSetting')) 

//服务管理 编辑佣金比例
export const editCommissionRate = (data, uuid) => (http.put(`/v1/cms/CommissionSetting/${uuid}`, data)); 